import { Alert, Link } from '@mui/material';

import type { SendProblem } from './useOtpVerification';

interface OtpSendAlertProps {
  problem: SendProblem;
}

/**
 * Why a code did not go out. When the API names the agent, their details are
 * the way forward — a locked account cannot be lifted from this screen.
 */
export const OtpSendAlert = ({ problem }: OtpSendAlertProps) => {
  const contact = problem.agentContact;

  return (
    <Alert severity="error" role="alert" className="rounded-lg">
      {problem.message}
      {contact !== null && (
        <span className="mt-1 block">
          Please contact your agent to unlock your account
          {contact.email !== null && (
            <>
              {' at '}
              <Link href={`mailto:${contact.email}`} color="inherit" underline="always">
                {contact.email}
              </Link>
            </>
          )}
          {contact.phone !== null && (
            <>
              {contact.email === null ? ' on ' : ' or '}
              <Link href={`tel:${contact.phone}`} color="inherit" underline="always">
                {contact.phone}
              </Link>
            </>
          )}
          .
        </span>
      )}
    </Alert>
  );
};
